/* eslint-disable */
import environment from '../enums/environment';

const getEnvironment = (isTestEnvironment: boolean) => (isTestEnvironment ? environment.test : environment.production);

export { getEnvironment };
